import React from 'react';
import BaseList from '@material-ui/core/List';

const List = (props) => <BaseList {...props} />;

export default List;
